/* eslint-disable tap/no-raw-text-js */
import Vue from 'vue';
import Vuex from 'vuex';
import { AppModuleGroup } from './modules/core/app/constants/app.constants';

Vue.use(Vuex);

export const createStore = () => {
  const modules = {};
  // By default, add core store.
  const requireModules = require.context('./modules', true, /\/(core)\/[a-z]+\/store\/index\.js$/);

  requireModules.keys().forEach((modulePath) => {
    const moduleName = modulePath.split('/')[2];
    const moduleConfig = requireModules(modulePath);
    modules[moduleName] = (moduleConfig.default || moduleConfig).store;
  });

  const store = new Vuex.Store({
    // strict: Env.isDevelopment(),
    state: {},
    mutations: {},
    actions: {},
    getters: {},
    modules,
  });

  return store;
};

const ADDED_MODULES = [];
/**
 *
 * @param {Vuex.Store} vuexStore
 * @param {String} project
 * @returns
 */
export const addStoreModules = async (vuexStore, project = AppModuleGroup.TA) => {
  if (ADDED_MODULES.includes(project) || !Object.values(AppModuleGroup).includes(project)) {
    return;
  }

  let loadModules = null;
  switch (project) {
    case AppModuleGroup.TA:
      loadModules = require.context(
        './modules',
        true,
        /\/ta\/[a-z]+\/store\/index\.js$/,
        'lazy-once'
      );
      break;
    case AppModuleGroup.SEO:
      loadModules = require.context(
        './modules',
        true,
        /\/seo\/[a-z]+\/store\/index\.js$/,
        'lazy-once'
      );
      break;
    case AppModuleGroup.TO:
      loadModules = require.context(
        './modules',
        true,
        /\/to\/[a-z]+\/store\/index\.js$/,
        'lazy-once'
      );
      break;
    case AppModuleGroup.AUDIENCE:
      loadModules = require.context(
        './modules',
        true,
        /\/audience\/[a-z]+\/store\/index\.js$/,
        'lazy-once'
      );
      break;
    case AppModuleGroup.AEOGEO:
      loadModules = require.context(
        './modules',
        true,
        /\/aeogeo\/[a-z]+\/store\/index\.js$/,
        'lazy-once'
      );
      break;
    default:
      loadModules = null;
  }

  if (loadModules) {
    const paths = loadModules.keys();
    // Load all modules in parallel for better performance
    const modulePromises = paths.map(async (modulePath) => {
      const moduleName = modulePath.split('/')[2];
      const moduleConfig = await loadModules(modulePath);
      const moduleStore = (moduleConfig.default || moduleConfig).store;
      return { moduleName, moduleStore };
    });

    // Wait for all modules to load, then register them
    const moduleResults = await Promise.all(modulePromises);

    // Register all modules to the store
    moduleResults.forEach(({ moduleName, moduleStore }) => {
      vuexStore.registerModule(moduleName, moduleStore);
    });

    ADDED_MODULES.push(project);
  }
};
